import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
    corporations : localStorage.getItem('corporations') && JSON.parse(localStorage.getItem('corporations'))  || [],
    subscribers: null
};

const module = {
    state,
    getters,
    mutations,
    actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/corporations/index.js